/**
 * Main product form + sticky bar each render their own <variant-radios>.
 * Same radio `name` + same `form` made only one control "checked" globally — the other UI looked blank.
 * Sticky radios now use unique names and no form; this keeps both UIs aligned when either changes.
 */
(function () {
  function fieldsetsIn(vr) {
    return [...vr.children].filter(function (el) {
      return el.tagName === 'FIELDSET';
    });
  }

  function isStickyPicker(vr) {
    return !!(vr && vr.closest && vr.closest('.ts-sticky-addtocart, .mobile-variants-sticky'));
  }

  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || input.tagName !== 'INPUT' || input.type !== 'radio') return;

    var picker = input.closest('variant-radios');
    if (!picker || !picker.dataset.section) return;

    var sectionId = picker.dataset.section;
    var esc = typeof CSS !== 'undefined' && CSS.escape ? CSS.escape(sectionId) : sectionId.replace(/"/g, '\\"');
    var peers = [].slice.call(document.querySelectorAll('variant-radios[data-section="' + esc + '"]'));
    if (peers.length < 2) return;

    var mainPicker = peers.find(function (p) {
      return !isStickyPicker(p);
    });
    var stickyPicker = peers.find(function (p) {
      return isStickyPicker(p);
    });
    if (!mainPicker || !stickyPicker) return;

    var mainFs = fieldsetsIn(mainPicker);
    var stickyFs = fieldsetsIn(stickyPicker);
    if (!mainFs.length || mainFs.length !== stickyFs.length) return;

    if (isStickyPicker(picker)) {
      var sIdx = stickyFs.findIndex(function (fs) {
        return fs.contains(input);
      });
      if (sIdx < 0) return;
      var mirror = [].find.call(mainFs[sIdx].querySelectorAll('input[type="radio"]'), function (r) {
        return r.value === input.value;
      });
      if (mirror && mirror !== input) {
        mirror.checked = true;
        mirror.dispatchEvent(new Event('change', { bubbles: true }));
      }
    } else {
      var mIdx = mainFs.findIndex(function (fs) {
        return fs.contains(input);
      });
      if (mIdx < 0) return;
      var twin = [].find.call(stickyFs[mIdx].querySelectorAll('input[type="radio"]'), function (r) {
        return r.value === input.value;
      });
      if (twin && !twin.checked) twin.checked = true;
    }
  });
})();

$(document).ready(function () {
  const $window = $(window);

  $('.filter-name-catelog-filter').on('click', function () {
    const href = this.getAttribute('href') || '';
    const targetId = href.includes('#') ? href.split('#')[1] : '';
    const $targetElement = targetId ? $('#' + targetId) : $();

    if ($targetElement.length) {
      let scrollOffset = $targetElement.offset().top;

      if ($window.width() <= 768) {
        scrollOffset -= 100;
      }

      $('html, body').animate({ scrollTop: scrollOffset }, 500);
    }

    $(this).addClass('active').siblings().removeClass('active');
  });
});

let cartEl = null;

async function updateCartDrawer() {
  // Cache the cart element
  if (!cartEl) {
    cartEl = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  if (!cartEl || typeof cartEl.renderContents !== 'function') return;

  const sections = (cartEl.getSectionsToRender?.().map((s) => s.id) || ['cart-drawer', 'cart-icon-bubble']).join(',');
  try {
    const cart = await fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' }).then((r) => r.json());
    window.cartJsCache = cart;
    if (typeof window.gmApplyCartJsCache === 'function') window.gmApplyCartJsCache(cart);
    const res = await fetch(`/?sections=${sections}`, { credentials: 'same-origin', cache: 'no-store' });
    if (!res.ok) throw new Error(`Failed to load sections: ${res.status}`);
    const data = await res.json();
    cart.sections = data;

    const quickAddModal = document.querySelector('quick-add-modal');
    if (quickAddModal) {
      document.body.addEventListener(
        'modalClosed',
        () => cartEl.renderContents(cart),
        { once: true }
      );
      quickAddModal.hide(true);
    } else {
      cartEl.renderContents(cart);
    }

    const drawer = document.querySelector('.drawer');
    if (drawer) {
      drawer.classList.remove('is-empty');
      drawer.classList.add('active');
    }
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'updateCartDrawer' } }));
  } catch (err) {
    console.error('Cart update error:', err);
    if (window.cartJsCache) cartEl.renderContents(window.cartJsCache);
  }
}
